import { render, staticRenderFns } from "./CallUsIcon.vue?vue&type=template&id=5ae8a7ab&"
import script from "./CallUsIcon.vue?vue&type=script&lang=js&"
export * from "./CallUsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports